import { render, staticRenderFns } from "./juntaDirectivaFormForm.vue?vue&type=template&id=3cdd1d4b"
import script from "./juntaDirectivaFormForm.vue?vue&type=script&lang=js"
export * from "./juntaDirectivaFormForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports